import React from 'react';
import {
  SvgIcon,
  makeStyles, ButtonProps,
} from '@material-ui/core';
import Button from './Button';

const useStyles = makeStyles((theme) => ({
  action: {
    '& + &': {
      marginLeft: theme.spacing(1)
    }
  },
  actionIcon: {
    marginRight: theme.spacing(1)
  }
}));

interface Props extends ButtonProps {
    icon?: React.ComponentType<any>,
    children: React.ReactNode,
    onChooseFile: (file: File) => void,
    inputProps?: Record<any, any>,
}

function UploadFileButton({
  icon: Icon, children, onChooseFile, inputProps, ...props
}: Props) {
  const classes = useStyles();

  return (
    <>
      <input
        id="upload-file"
        // @ts-ignore
        onChange={(event) => onChooseFile(event.target.files[0])}
        {...inputProps}
        type="file"
        hidden
      />
      <Button
        {...props}
        // @ts-ignore
        onClick={() => document.getElementById('upload-file').click()}
      >
        {
          Icon && (
            <SvgIcon
              fontSize="small"
              className={classes.actionIcon}
            >
              <Icon />
            </SvgIcon>
          )
        }
        {children}
      </Button>
    </>
  );
}

export default UploadFileButton;
